export const FETCH_ITEM = 'fetchItem';
export const SET_FOOTER = 'setFooter';
export const STORE_MODULE_NAME = 'vacancy';
export const SET_VACANCY = 'setVacancy';
export const SET_NOTHING_FOUND = 'setNothingFound';



// WEBPACK FOOTER //
// ./src/pages/vacancies/card/consts.ts